export const BG_EXCHANGE_RATE = 1.95583;
